import { post, auth } from '../index';
const ENDPOINT = '/patient';

export const addAdvancedParameter = (data: any) => {
  const { patientId } = data;
  const url = `${ENDPOINT}/${patientId}/advanced-parameters`;
  return post(url, data.payload, auth());
};
